module.exports = __webpack_public_path__ + "img/Christine-VanDoren.5c0115fb.jpeg";